import React from "react";
import { useTranslation } from "react-i18next";
import { INPUTS_PAGE_NAV_TITLE } from "pages/InputsPage";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import PageNavigation from "components/common/PageNavigation";
import DocsHelper from "util/DocsHelper";
import { ForwarderInputsOverview } from "./forwarder-inputs-tab";
import ForwarderInputsNotifications from "./states/ForwarderInputsNotifications";
const ForwarderInputsPage = () => {
  const { t } = useTranslation("enterprise_forwarder");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("inputs_page.title") }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: INPUTS_PAGE_NAV_TITLE })), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("inputs_page.title"),
      documentationLink: {
        title: t("common.inputs_documentation"),
        path: DocsHelper.PAGES.INPUTS
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("inputs_page.description"))
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ForwarderInputsNotifications, null), /* @__PURE__ */ React.createElement(ForwarderInputsOverview, null))));
};
export default ForwarderInputsPage;
